import React, { ChangeEvent, FC } from 'react'
import styles from 'styles/components/form.module.scss'
import { Spacer } from 'components/Utility'

type Props = {
  disabled?: boolean
  isChecked: boolean
  label: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
  value: string
}

const RadioButton: FC<Props> = React.memo((props) => {
  const { disabled = false, isChecked, label, onChange, value } = props

  return (
    <label className={styles.radio} htmlFor={value}>
      <input
        className={styles.radio__input}
        disabled={disabled}
        checked={isChecked}
        id={value}
        onChange={(e) => onChange(e)}
        type={'radio'}
        value={value}
      />
      <span className={styles.radio__dummy} />
      <Spacer size={8} />
      <span>{label}</span>
    </label>
  )
})

export default RadioButton
